import { Guid, isNotNil, Nillable } from '@web/utils';
import {
  ShippingMethodCode,
  ShippingMethodPropertyCode,
} from '../../shared/enums';
import { ShippingMethodProperty } from '../../shared/models';

export class PublicSubscriptionShippingMethodCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      code: ShippingMethodCode;
      name: string;
      description: string;
      shippingPrice: number;
      totalPrice: number;
      properties: ShippingMethodProperty[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): ShippingMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get properties(): ShippingMethodProperty[] {
    return this.data.properties;
  }

  public get isInternationalInPostGeowidget(): boolean {
    if (!this.hasInPostGeowidgetProperty) {
      return false;
    }

    return (
      this.code === ShippingMethodCode.InPostInternationalParcelLocker ||
      this.code === ShippingMethodCode.MondialRelayInternational
    );
  }

  public get isDomesticInPostGeowidget(): boolean {
    if (!this.hasInPostGeowidgetProperty) {
      return false;
    }

    return this.code === ShippingMethodCode.InPostParcelLocker;
  }

  public get inPostGeowidgetProperty(): Nillable<ShippingMethodProperty> {
    return this.properties.find(
      (property) =>
        property.code === ShippingMethodPropertyCode.InPostGeowidget,
    );
  }

  public get shippingPrice(): number {
    return this.data.shippingPrice;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  /* prettier-ignore */
  private get hasInPostGeowidgetProperty(): boolean {
    return isNotNil(this.inPostGeowidgetProperty);
  }
}
